<template>
    <div class="portal-container">
        <div class="portal">
            <div class="title">CCT Connect</div>
            <div class="card-container">
                <div v-for="card in cards">
                    <LinkCard :name="card.name" :url="card.url" :filename="card.img"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LinkCard from '@/components/LinkCard.vue';

export default {
  name: 'Portal',
  components: {
    LinkCard
},
  data() {
    return {
        cards: [
        {
                name: 'ดาวน์โหลดไฟล์ Setup',
                url: 'https://drive.google.com/file/d/1W9QyawcaNMo65NNM2kejS6RWtDvUCoYh/view?usp=sharing',
                img: require('@/assets/icons/download.svg')
            },
            {
                name: 'ดาวน์โหลดไฟล์ Update โปรแกรม',
                url: 'https://drive.google.com/file/d/1Uc_HkHIhSEJEHs2E6TKw_9KBnPUoQwPB/view?usp=sharing',
                img: require('@/assets/icons/download.svg')
            },
            {
                name: 'งานบุคลากร',
                url: 'https://ncs.cctconnect.net/hrm',
                img: require('@/assets/icons/personal-data.svg')
            },
            {
                name: 'งานทะเบียน',
                url: 'https://ncs.cctconnect.net/student',
                img: require('@/assets/icons/register.svg')
            },
            {
                name: 'ประเมินพฤติกรรมนักเรียน',
                url: 'https://ncssdq.cctconnect.net/IndexSDQ',
                img: require('@/assets/icons/search-behavior.svg')
            },
            {
                name: 'ระบบการเงิน',
                url: 'https://ncsfin.cctconnect.net/',
                img: require('@/assets/icons/coins.svg')
            },
            {
                name: 'งานพัสดุ-จัดซื้อ',
                url: 'http://ncs.cctconnect.net:8080/NCSStock',
                img: require('@/assets/icons/boxes-stacked.svg')
            },
            {
                name: 'งานแผนงบประมาณ',
                url: 'http://ncs.cctconnect.net:8080/NCSbudgetplan',
                img: require('@/assets/icons/chart-pie.svg')
            },
            {
                name: 'งานบัญชี',
                url: 'https://ncsaccount.cctconnect.net/',
                img: require('@/assets/icons/file-invoice-dollar.svg')
            },
            {
                name: 'เอกสาร',
                url: 'https://ncsdoc.cctconnect.net/Index',
                img: require('@/assets/icons/folder-open-regular.svg')
            },
            {
                name: 'รายงานผลการเรียน',
                url: 'https://ncsreport.cctconnect.net/loginadmin',
                img: require('@/assets/icons/file-regular.svg')
            },
            {
                name: 'ตรวจสอบผลการเรียน',
                url: 'https://ncsreport.cctconnect.net/Index',
                img: require('@/assets/icons/book-open.svg')
            },
            {
                name: 'ประเมินสมรรถนะสำคัญ',
                url: 'https://ncscomp.cctconnect.net/loginteacher',
                img: require('@/assets/icons/search-behavior.svg')
            },
            {
                name: 'จัดการรหัสผ่าน',
                url: 'https://ncsper.cctconnect.net/login',
                img: require('@/assets/icons/security-protection.svg')
            }
        ]
    }
  }
}
</script>

<style>
.portal-container {
    max-width: 1200px;
    padding: 0%;
    margin: auto;
}
.portal {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 16px 0;
}
.title {
    font-size: 2.5rem;
    font-weight: 600;
    text-decoration: underline;
    text-align: center;
    padding-bottom: 32px;
}
.card-container {
    display: grid;
    row-gap: 16px;
    column-gap: 16px;
    grid-template-columns: 1fr 1fr 1fr;
}
@media only screen and (max-width: 1024px) {
    .portal {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 16px 32PX;
    }
}
@media only screen and (max-width: 768px) {
    .card-container {
        row-gap: 8px;
        column-gap: 8px;
        grid-template-columns: 1fr 1fr;
    }
    .portal {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 16px 16PX;
    }
}
</style>
